import "./assets/styles/styles.scss";
import "./assets/js/scrollreveal";
import "./assets/js/bigpicture"; 

const loader = document.querySelector(".container-div");
const loading = window.addEventListener("DOMContentLoaded", function(e) {
  loader.style.display = "none";
});